import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/shared/link';
import styles from './social-item.module.scss';
import FacebookIcon from './svg/facebook.inline.svg';
import InstagramIcon from './svg/instagram.inline.svg';
import LinkedinIcon from './svg/linkedin.inline.svg';
import TwitterIcon from './svg/twitter.inline.svg';
import YouTubeIcon from './svg/youtube.inline.svg';

const icons = {
  facebook: FacebookIcon,
  instagram: InstagramIcon,
  linkedin: LinkedinIcon,
  twitter: TwitterIcon,
  youtube: YouTubeIcon,
};

const SocialItem = ({ url, iconName }) => {
  const Icon = icons[iconName];
  return (
    <Link className={styles.wrapper} to={url} target="_blank" rel="noreferrer">
      <Icon />
    </Link>
  );
};

SocialItem.propTypes = {
  url: PropTypes.string.isRequired,
  iconName: PropTypes.oneOf(Object.keys(icons)).isRequired,
};

export default SocialItem;
